const datavisual = {
  state: {
    showSideBar: true,
    showPropsBar: true,
  },
  mutations: {
    setShowSideBar: (state, v) => {
      state.showSideBar = v;
    },
    setShowPropsBar: (state, v) => {
      state.showPropsBar = v;
    },
  },
  actions: {
    doShowSideBar({commit}, v) {
      commit("setShowSideBar", v);
    },
    doShowPropsBar({commit}, v) {
      commit("setShowPropsBar", v);
    },
  },
}

export default datavisual

